import { render, staticRenderFns } from "./CreateAffiliatePage.vue?vue&type=template&id=a26cba92&"
import script from "./CreateAffiliatePage.vue?vue&type=script&lang=ts&"
export * from "./CreateAffiliatePage.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAffiliatePage.vue?vue&type=style&index=0&id=a26cba92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports